import './css/404.css';
import React from 'react';
import react from 'react';

class Page404 extends react.Component {
        render() {
            return(
                <React.Fragment>
                    <div className="ternary-system">
                    <div className="sun primary"></div>
                    <div className="sun secondary"></div>
                    <div className="sun ternary"></div>
                    </div>
                    <div className="sand">
                    <div className="pendulums">
                    <div className="pendulum">
                        <div className="bar"></div>
                        <div className="motion">
                        <div className="string"></div>
                        <div className="weight"></div>
                        </div>
                    </div>
                    <div className="pendulum shadow">
                        <div className="bar"></div>
                        <div className="motion">
                        <div className="string"></div>
                        <div className="weight"></div>
                        </div>
                    </div>
                    </div></div>
                    <div className="pyramid"></div>
                    <div className="text">
                    <h1 className="title"><strong>404</strong><em>Page not found.</em></h1>
                    <p>Wrong way!</p>
                    </div>
                </React.Fragment>
            )
        }
}

export default Page404;